import { debounce } from 'lodash';
import { useCallback } from 'react';
import { DebouncedFunc } from 'lodash';

type AnyFunc = (...args: any[]) => Promise<any>;

const useDebounceLiveUpdate = (fun: AnyFunc, time = 100): DebouncedFunc<AnyFunc> => {
  return useCallback(debounce(fun, time), []);
};

export { useDebounceLiveUpdate };
